<template>
  <div class="container-fluid m-0 p-0">

    <div class="row text-left bg-light border-bottom d-flex justify-content-between">
      <h5 class="text-dark font-weight-bolder ml-3 mt-3 mb-3">
        P&I Reports
      </h5>

      <form class="" @submit.prevent="">
        <div class="form-inline">
          <div class="form-group mr-5">
            <div class="input-group ml-2 mt-3 mb-3">
              <!--            <label for="search" class="input-group-prepend input-group-text form-control-xs bg-white border-0">Search By:</label>-->
              <div>
                <select name="search" id="searchKey" class="form-control form-control-xs left-rounded"
                        @change="searchFieldFocus()"
                        v-model="pandiReportSearchParam.searchKey"
                >
                  <option value="all">All</option>
                  <option value="ipn">Crew IPN</option>
                  <option value="first_name">First Name</option>
                  <option value="last_name">Last Name</option>

                </select>
              </div>

              <input type="text" id="searchFieldPandiReport"
                     style="width: 400px;"
                     class="form-control form-control-xs"
                     aria-describedby="basic-addon2"
                     :placeholder="keyPlaceHolder"
                     v-model="pandiReportSearchParam.searchValue"
              >

              <div class="input-group-append">
                <button type="submit" class="input-group-text input-group-append">
                  <i class="fas fa-search" style="color:#007bff"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group mr-3">
            <label for="date-to" class="form-control-xs font-weight-bold ml-2 mr-1">
              Select:
            </label>
            <select id="activeOption0" class="form-control form-control-xs input-group-append"
                    v-model="selectPandiFilter">
              <!--          <option :value="''">-&#45;&#45; ALL -&#45;&#45;</option>-->
              <option value="manning">Manning</option>
              <option value="vessel">Vessel</option>
              <option value="crew">Crew</option>
            </select>
          </div>
          <div class="form-group">
            <label for="date-to" class="form-control-xs font-weight-bold ml-2 mr-1">
              Case Status:
            </label>
            <select id="activeOption0" class="form-control form-control-xs input-group-append"
                    v-model="pandiReportSearchParam.pandiStatus"
            >
              <!--          <option :value="''">-&#45;&#45; ALL -&#45;&#45;</option>-->
              <option value="all">ALL</option>
              <option :value="1">ACTIVE</option>
              <option :value="0">CLOSED</option>
            </select>
          </div>
        </div>

      </form>

      <div>
        <div class="input-group form-inline justify-content-between mt-3 mb-3">
          <!--          <button id="generateReport" class="btn btn-outline-success btn-xs p-1 d-flex align-items-center mr-3 mx-3"-->
          <!--                  @click="generatePandiReport">-->
          <!--            <i class="fas fa-file-excel fa-2x mx-1"></i>-->
          <!--            Generate Report-->
          <!--          </button>-->


          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </div>
      </div>


    </div>


    <div class="row mt-3">
      <div class="col col-12 input-group form-inline justify-content-center ">

        <div class="form-inline">

          <template v-if="selectPandiFilter == 'manning'">
            <div class="form-group mr-5">
              <label for="manning" class="form-control-xs font-weight-bold ml-3 mr-1"> Manning: </label>
              <select class="form-control form-control-xs" id="manning"
                      v-model="pandiReportSearchParam.manning">
                <option :value="0" id="manningOption0" disabled selected>---Select Manning ---</option>
                <option value="0" v-if="isSystemAdmin || isPrincipal">ALL MANNINGS</option>
                <option v-for="manningKey in getManningLists"
                        :key="manningKey.id"
                        :title="manningKey.name"
                        :value="manningKey.id" selected>
                  {{ manningKey.alias }}
                </option>
              </select>
            </div>
          </template>


          <template v-if="selectPandiFilter == 'manning' || selectPandiFilter == 'vessel'">
            <div class="form-group mr-5">
              <label for="vessels" class="form-control-xs font-weight-bold ml-2 mr-1"> Vessel: </label>
              <select class="form-control form-control-xs" id="vessels"
                      v-model="pandiReportSearchParam.vessel">
                <option :value="0" id="vesselOption0" disabled selected>---Select Vessel ---</option>
                <option value="">ALL VESSELS</option>
                <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">
                  {{ vessel.name }}
                </option>
              </select>
            </div>
          </template>

          <template v-if="selectPandiFilter == 'manning' || selectPandiFilter == 'vessel'">
            <div class="form-group mr-5">
              <label for="rank" class="form-control-xs font-weight-bold ml-2 mr-1"> Rank: </label>
              <select class="form-control form-control-xs" id="rank"
                      v-model="pandiReportSearchParam.rank">
                <option :value="0" id="rankOption0" disabled selected>---Select Ranks ---</option>
                <option value="">ALL RANKS</option>
                <option v-for="rankKey in rankKeys"
                        :key="rankKey.id"
                        :value="rankKey.id"
                        :title="rankKey.name"
                >{{ rankKey.alias }}
                </option>
              </select>
            </div>
          </template>

          <template v-if="selectPandiFilter == 'manning' || selectPandiFilter == 'vessel'">
            <div class="form-group mr-5">
              <label for="rank" class="form-control-xs font-weight-bold ml-2 mr-1"> Medical Type: </label>
              <select id="activeOption0" class="form-control form-control-xs input-group-append"
                      v-model="pandiReportSearchParam.medicalType"
              >
                <option value="0">ALL</option>
                <option value="1">Injury</option>
                <option value="2">Illness</option>
              </select>
            </div>
          </template>

          <template v-if="selectPandiFilter == 'manning'">

            <div class="form-group">
              <label for="date-to" class="form-control-xs font-weight-bold ml-2 mr-1">
                Date From:
              </label>
              <input type="date" id="date-from" class="form-control form-control-xs"
                     v-model="pandiReportSearchParam.date_from">
            </div>

            <div class="form-group">
              <label for="date-to" class="form-control-xs font-weight-bold ml-2 mr-1">
                Date To:
              </label>
              <input type="date" id="date-to" class="form-control form-control-xs"
                     v-model="pandiReportSearchParam.date_to">
            </div>
          </template>


          <template v-if="selectPandiFilter == 'vessel'">

            <div class="form-group">
              <label for="date-to" class="form-control-xs font-weight-bold ml-2 mr-1">
                Date From:
              </label>
              <input type="month"
                     id="start"
                     name="start"
                     class="form-control form-control-xs"
                     v-model="pandiReportSearchParam.from_monthYear"
              >
            </div>

            <div class="form-group mr-5">
              <label for="date-to" class="form-control-xs font-weight-bold ml-2 mr-1">
                Date To:
              </label>
              <input type="month"
                     id="start"
                     name="start"
                     class="form-control form-control-xs"
                     v-model="pandiReportSearchParam.to_monthYear">
            </div>


          </template>

        </div>


      </div>
    </div>


    <div class="row py-2">

      <div class="col-sm-12 py-2 mb-2">
        <hr class="m-0"/>
      </div>

      <div class="table-responsive my-2">

        <template v-if="selectPandiFilter != 'crew'">
          <!-- add to class optional:  table-striped -->
          <table id="pandiTableId"
                 class="table table-hover table-bordered table-template-1 text-small my-2">
            <thead>
            <tr class="pandi-nowrap">
              <th rowspan="2" class="sticky-scroll-1" style="min-width: 44px !important; background: #d3d3d3;">No</th>
              <th rowspan="2" class="sticky-scroll-2" style="min-width: 160px !important; background: #d3d3d3;">Vessel
              </th>
              <th rowspan="2" class="sticky-scroll-3" style="background: #d3d3d3;">Name</th>
              <th rowspan="2">Endorse P&I</th>
              <th rowspan="2">Manning</th>
              <th rowspan="2">Rank</th>
              <!--            <th rowspan="2">Position</th>-->
              <th rowspan="2">Age</th>
              <th rowspan="2"><span class="d-block">Date</span>Embarked</th>
              <th rowspan="2"><span class="d-block">Date</span>Disembarked</th>
              <th rowspan="2"><span class="d-block">Period on Board</span> (Month)</th>
              <th colspan="2">FINISHED CONTRACT</th>
              <th rowspan="2" v-if="pandiReportSearchParam.medicalType == 2 || pandiReportSearchParam.medicalType == 0">
                Illness
              </th>
              <th rowspan="2" v-if="pandiReportSearchParam.medicalType == 1 || pandiReportSearchParam.medicalType == 0">
                Injury
              </th>
              <th rowspan="2"><span class="d-block">Vessel Deviation to</span>discharge the patient</th>
              <th rowspan="2"><span class="d-block">Success to send</span>replacement</th>
              <th rowspan="2"><span class="d-block">K-line</span>Clinic<span class="d-block">(PEME)</span></th>
              <th rowspan="2"><span class="d-block">Other</span>Clinic<span class="d-block">(PEME)</span></th>
              <th rowspan="2">Date of PEME</th>
              <th colspan="2">STATUS</th>
              <th rowspan="2">Plan to Re-hire</th>
              <th rowspan="2"><span class="d-block">Days on</span>Treatment<span class="d-block">(Days)</span></th>
              <th rowspan="2"><span class="d-block">P&I</span>Case No.</th>
              <th rowspan="2">P&I CLUB</th>
              <th colspan="2"><span class="d-block">P&I CLUB</span>Local Corespondent</th>
              <th rowspan="2"><span class="d-block">Below</span>Deductible</th>
              <th colspan="2"><span class="d-block">Total Expense</span></th>
              <th rowspan="2">Status</th>
            </tr>
            <tr>
              <!--            FINISHED CONTRACT-->
              <th>YES</th>
              <th>NO</th>

              <!--            STATUS-->
              <th>Date</th>
              <th>Status</th>

              <!--            P&I CLUB Local Corespondent-->
              <th>Pandiman</th>
              <th>Pandiphil</th>


              <th>Philippine Peso (PHP)</th>
              <th>United States Dollar (USD)</th>

            </tr>
            </thead>

            <tbody class="text-small">
            <tr v-if="isLoading">
              <td colspan="100%">
                <app-loading></app-loading>
              </td>
            </tr>

            <template v-else>
              <tr v-for="(pandiReport, index) in pandiReports" :key="pandiReport.id" class="pandi-nowrap">
                <td class="text-center sticky-scroll-1">{{ index + 1 }}</td>
                <td class="text-left sticky-scroll-2">{{ pandiReport.vesselName }}</td>
                <td class="text-left sticky-scroll-3">
                  <router-link :to="{name:'CrewActivity',params:{id:pandiReport.crew_id}}" target="_blank"
                               v-if="pandiReport.fullName" class="mb-0">{{ pandiReport.fullName }}
                  </router-link>
                </td>
                <!--              <td class="text-center">{{ pandiReport.position }}</td>-->
                <td class="text-center">{{ pandiReport.endorsementDate }}</td>
                <td class="text-center">{{ pandiReport.manning }}</td>
                <td class="text-center">{{ pandiReport.position }}</td>
                <!--              <td class="text-center">{{ pandiReport.position }}</td>-->
                <td class="text-center">{{ pandiReport.birthdate | age }}</td>
                <td class="text-center">{{ pandiReport.dateEmbarked }}</td>
                <td class="text-center"> {{ pandiReport.dateDisembarked }}</td>
                <td class="text-center"> {{ pandiReport.periodOnBoard }}</td>
                <td class="text-center">
                  {{ pandiReport.finishedContract == 1 ? 'X' : '' }}
                </td>
                <td class="text-center">
                  {{ pandiReport.finishedContract == 0 ? 'X' : '' }}
                </td>
                <td class="text-center"
                    v-if="pandiReportSearchParam.medicalType == 2 || pandiReportSearchParam.medicalType == 0">
                  <template v-if="pandiReport.medical_type_id == 2">{{ pandiReport.injuries }}</template>
                </td>
                <td class="text-center"
                    v-if="pandiReportSearchParam.medicalType == 1 || pandiReportSearchParam.medicalType == 0">
                  <template v-if="pandiReport.medical_type_id == 1">{{ pandiReport.injuries }}</template>
                </td>
                <td class="text-center">
                  {{ pandiReport.discharge }}
                </td>
                <td class="text-center">
                  {{ pandiReport.replacement }}
                </td>
                <td class="text-center">
                <span v-for="cert in pandiReport.medicalCertificate"
                      :key="cert.id"
                      v-show="cert.clinic_id == 4">
                  {{ cert.clinic }}
                </span>
                </td>
                <td class="text-center">
                <span v-for="cert in pandiReport.medicalCertificate"
                      :key="cert.id"
                      v-show="cert.clinic_id != 4">
                  {{ cert.clinic }}
                </span>
                </td>
                <td class="text-center">
                <span v-for="cert in pandiReport.medicalCertificate"
                      :key="cert.id">
                  {{ cert.fitness_date }}
                </span>
                </td>
                <td class="text-center">
                  {{ pandiReport.endorsementDate }}
                </td>
                <td class="text-center">
                  {{ pandiReport.pandiResult }}
                </td>
                <td class="text-center">
                  {{ pandiReport.rehire_plan }}
                </td>
                <td class="text-center">
                  {{ pandiReport.daysTreatment }}
                </td>
                <td class="text-center">
                  {{ pandiReport.pandiCode }}
                </td>
                <td class="text-center">
                  {{ pandiReport.pandiClub }}
                </td>
                <td class="text-center">
                  {{ pandiReport.localCorrespondent === 'PANDIMAN' ? 'X' : '' }}
                </td>

                <td class="text-center">
                  {{ pandiReport.localCorrespondent === 'PANDIPHIL' ? 'X' : '' }}
                </td>
                <td class="text-center">
                  {{ pandiReport.deductible === 1 ? 'X' : '' }}
                </td>
                <td class="text-center revert-wrap" style="min-width: 250px">
                  {{ pandiReport.ph_total_expenses }}
                </td>

                <td class="text-center revert-wrap" style="min-width: 250px">
                  {{ pandiReport.us_total_expenses }}
                </td>
                <td class="text-center">
                  {{ pandiReport.remarks }}
                </td>
              </tr>
            </template>

            </tbody>
          </table>
        </template>


        <table id="pandiTableId2"
               v-if="selectPandiFilter == 'crew'"
               class="table table-hover table-bordered table-template-1 text-small my-2">
          <thead>
          <tr>
            <th rowspan="2">No</th>
            <th rowspan="2">Manning</th>
            <th rowspan="2">Rank</th>
            <th rowspan="2">Name</th>
            <th rowspan="2">Check up Date</th>
            <th rowspan="2">Port</th>
            <th rowspan="2"><span class="d-block">Disembarkation</span>Date</th>
            <th rowspan="2">Arrival Manila Date</th>
            <th rowspan="2">Endorse P&I</th>
            <th rowspan="2"><span class="d-block">Type of Illness or</span> Injury</th>
            <th rowspan="2"><span class="d-block">Medical Check up</span> Report</th>
            <th rowspan="2">120 Days?</th>
            <th colspan="2">Cost</th>
          </tr>
          <tr>

            <!--            Cost -->
            <th>Dollar</th>
            <th>Peso</th>

          </tr>
          </thead>

          <tbody class="text-small">
          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(pandiReport, index) in pandiReports" :key="pandiReport.id" class="pandi-nowrap">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ pandiReport.manning }}</td>
              <td class="text-center">{{ pandiReport.position }}</td>
              <td class="text-left">
                <router-link :to="{name:'CrewActivity',params:{id:pandiReport.crew_id}}" target="_blank"
                             v-if="pandiReport.fullName" class="mb-0">{{ pandiReport.fullName }}
                </router-link>
              </td>
              <td class="text-center"> {{ pandiReport.latestCheckup }}</td>
              <td class="text-center">{{ pandiReport.port }}</td>
              <td class="text-center">{{ pandiReport.dateDisembarked }}</td>
              <td class="text-center">{{ pandiReport.arrivalManila }}</td>
              <td class="text-center"> {{ pandiReport.endorsementDate }}</td>
              <td class="text-center revert-wrap" style="min-width: 50px" > {{ pandiReport.injuries }}</td>
              <td class="text-center revert-wrap" style="min-width: 100px">
                <ul class="text-left" v-for="(checkup, index) in pandiReport.pandiCheckups.slice().reverse()"
                    :key="checkup.id"
                    style="list-style: none; padding-left: 0;">
                  <li>
                <span class="font-weight-bold">
              Medical Report {{ index + 1 }}
            </span>
                    - {{ checkup.checkup_date }}
                  </li>
                </ul>
              </td>

              <td class="text-center" v-if="pandiReport.dateArrivalManilaToNow > 120">
                <i class="fas fa-check" style="color:#28a745; font-size: 15px; "></i>
              </td>

              <td class="text-center" v-if="pandiReport.dateArrivalManilaToNow < 120">
                {{ pandiReport.dateArrivalManilaToNow }}
              </td>

              <td class="text-center">
                {{ pandiReport.us_total_expenses }}
              </td>
              <td class="text-center">
                {{ pandiReport.ph_total_expenses }}
              </td>

            </tr>
          </template>

          </tbody>
        </table>


      </div>

    </div>

  </div>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {gateMixin} from '@/mixins/gateMixin';
import AppLoading from '@/components/elements/AppLoading';
import {mapGetters, mapActions} from 'vuex';
import {paginationMixin} from '@/mixins/paginationMixin';
import {ReportService} from "@/services/ReportService";
import {DateService} from "@/services/Utilities/DateService";

export default {
  name: 'GeneratePandIReports',
  mixins: [vueAppMixin, gateMixin, paginationMixin],
  components: {AppLoading},

  data() {
    return {
      selectPandiFilter: 'manning',

      params: {
        page: 0,
      },
      downloading: false,
    };
  },

  methods: {
    ...mapActions([
      'getPandiReports',
      'getVesselKeys',
      'getRankKeys',
      'getManningKeys',
      'clearPandiReport',
    ]),

    filterPandiReports() {
      this.params.page = this.pagination.currentPage;
      this.getPandiReports(this.params);
    },

    async setPage(page) {
      this.pagination.currentPage = page;
      await this.filterPandiReports();
    },

    searchFieldFocus() {
      document.getElementById('searchFieldPandiReport').focus();
    },

    searchPandiReport() {
      let page = this.pagination.currentPage;
      let params = {
        page: page,
        searchKey: this.pandiReportSearchParam.searchKey,
        searchValue: this.pandiReportSearchParam.searchValue,
        manning: this.pandiReportSearchParam.manning,
        medicalType: this.pandiReportSearchParam.medicalType,
        vessel: this.pandiReportSearchParam.vessel,
        rank: this.pandiReportSearchParam.rank,
        pandiStatus: this.pandiReportSearchParam.pandiStatus,
        date_from: this.pandiReportSearchParam.date_from,
        date_to: this.pandiReportSearchParam.date_to,
        from_monthYear: this.pandiReportSearchParam.from_monthYear,
        to_monthYear: this.pandiReportSearchParam.to_monthYear,
      };

      // if(this.pandiReportSearchParam.pandiStatus !== '') {
      //   params['pandiStatus'] = this.pandiReportSearchParam.pandiStatus;
      // }

      this.getPandiReports(params);
    },

    generatePandiReport() {
      this.downloading = true;
      ReportService.generatePandiReport(this.pandiReportSearchParam);
      this.downloading = false;
    }


  },

  computed: {
    ...mapGetters([
      'pandiReports',
      'manningKeys',
      'rankKeys',
      'vesselKeys',
      'pagination',
      'pandiReportPagination',
      'pandiReportSearchParam',
    ]),

    keyPlaceHolder() {
      let placeholder = 'Type Anything Here';
      switch (this.pandiReportSearchParam.searchKey) {
        case 'All':
          placeholder = 'Type Anything Here';
          break;
        case 'ipn':
          placeholder = 'Type Crew IPN';
          break;
        case 'first_name':
          placeholder = 'Type Crew First Name';
          break;
        case 'last_name':
          placeholder = 'Type Crew Last Name';
          break;
      }
      return placeholder;
    },

    // paginationPages() {
    //   let pages = [];
    //   let currentPage = this.pandiReportPagination.currentPage;
    //   let lastPage = this.pandiReportPagination.lastPage;
    //   if (lastPage > 1) {
    //     let initialLimit = 1;
    //     if (currentPage + 5 > lastPage) {
    //       initialLimit = lastPage - 10;
    //     } else if (currentPage > 6) {
    //       initialLimit = currentPage - 5;
    //     }
    //     initialLimit = initialLimit < 1 ? 1 : initialLimit;
    //     for (let i = initialLimit; i <= initialLimit + 10; i++) {
    //       pages.push(i);
    //       if (i >= lastPage) {
    //         break;
    //       }
    //     }
    //   }
    //   return pages;
    // },


    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    },

  },

  created() {
    // this.getPandiReports();
    this.getVesselKeys();
    this.getRankKeys();
    this.getManningKeys();

    this.updatePandiReportList = _.debounce(this.searchPandiReport, 500);
  },

  beforeDestroy() {
    this.clearPandiReport();
  },

  watch: {
    'selectPandiFilter'() {
      if (this.selectPandiFilter == 'manning') {
        this.pandiReportSearchParam.date_from = DateService.dateStartOfYear();
        this.pandiReportSearchParam.date_to = DateService.dateToday();

        this.pandiReportSearchParam.to_monthYear = null;
        this.pandiReportSearchParam.from_monthYear = null;

      }

      if (this.selectPandiFilter == 'vessel') {
        this.pandiReportSearchParam.date_from = null;
        this.pandiReportSearchParam.date_to = null;
      }

      if (this.selectPandiFilter == 'crew') {
        this.pandiReportSearchParam.date_from = null;
        this.pandiReportSearchParam.date_to = null;

        this.pandiReportSearchParam.to_monthYear = null;
        this.pandiReportSearchParam.from_monthYear = null;

      }

    },

    'pandiReportSearchParam.searchValue'() {
      this.updatePandiReportList();
    },

    'pandiReportSearchParam.vessel'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },

    'pandiReportSearchParam.rank'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },

    'pandiReportSearchParam.manning'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
      if (this.isOchg && this.isSystemAdmin) {
        this.getVesselKeys({manningId:this.pandiReportSearchParam.manning})
      }
    },

    'pandiReportSearchParam.pandiStatus'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },

    'pandiReportSearchParam.date_from'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },

    'pandiReportSearchParam.date_to'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },


    'pandiReportSearchParam.from_monthYear'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },


    'pandiReportSearchParam.to_monthYear'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },


    'pandiReportSearchParam.medicalType'() {
      this.pagination.currentPage = 0;
      this.updatePandiReportList(this.pandiReportSearchParam);
    },

  },

  mounted() {
    // this.updatePandiReportList(this.pandiReportSearchParam)
    this.updatePandiReportList(this.pandiReportSearchParam);

  }

};

</script>

<style scoped>
.nav-link.active, .nav-link:hover {
  background-color: #e87c87;
  color: white !important;
}

.pandi-nowrap * {
  white-space: pre;
}

.revert-wrap * {
  white-space: normal;
}

/*#pandiTableId thead tr th{*/
/*  background: #d6fefe;*/
/*}*/

#pandiTableId > thead > tr > th {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

#pandiTableId tbody tr *, #pandiTableId thead tr * {
  font-size: 11px;
}

#pandiTableId2 tbody tr *, #pandiTableId2 thead tr * {
  font-size: 11px;
}

#pandiTableId tbody tr:nth-child(odd) .sticky-scroll-1,
#pandiTableId tbody tr:nth-child(odd) .sticky-scroll-2,
#pandiTableId tbody tr:nth-child(odd) .sticky-scroll-3 {
  background: #e3e0e0;
}

#pandiTableId tbody tr:nth-child(even) .sticky-scroll-1,
#pandiTableId tbody tr:nth-child(even) .sticky-scroll-2,
#pandiTableId tbody tr:nth-child(even) .sticky-scroll-3 {
  background: #f1f1f1;
}

#pandiTableId tbody tr .sticky-scroll-1,
#pandiTableId thead tr .sticky-scroll-1 {
  position: sticky;
  left: 0;
  z-index: 2;
  width: inherit;
  padding: 0 20px;
}

#pandiTableId tbody > tr .sticky-scroll-2,
#pandiTableId thead tr .sticky-scroll-2 {
  position: sticky;
  left: 44px;
  z-index: 2;
  width: inherit;
  padding: 0 20px;
}

#pandiTableId tbody > tr .sticky-scroll-3,
#pandiTableId thead tr .sticky-scroll-3 {
  position: sticky;
  left: 205px;
  z-index: 2;
  width: inherit;
  padding: 0 20px;
}

</style>
